import { TunnelStep } from '../model/tunnel-step-type';
import { CONFIG_CONTEXT } from '../../../enum/config-context.enum';
import { TunnelDataState } from '../../../stores/tunnel/model/tunnel-data-state';
import { BasketConfigurationData } from '../../../stores/tunnel/model/configuration-data/basket-configuration-data';
import { BaseValidationComponent } from '../common/base-validation/base-validation.component';
import { BasketTunnelProductsComponent } from './basket-tunnel-products/basket-tunnel-products.component';

/** Indique si la liste d'achat ne contient aucun article. */
function isPurchaseListEmpty(stateValue: TunnelDataState): boolean {
  const configuration = stateValue.configurationData.get(CONFIG_CONTEXT.BASKET) as BasketConfigurationData;
  return !configuration?.productCount;
}

export const BASKET_TUNNEL_STEPS: TunnelStep[] = [
  {
    component: BasketTunnelProductsComponent,
    context: CONFIG_CONTEXT.BASKET,
    title: "Liste d'achat",
    hideProductList: true,
    hidePreviousStepAction: true,
    hideDiscountAction: true,
    canPrint: false,
    skipCheckBomEmpty: true,
  },
  {
    component: BaseValidationComponent,
    context: CONFIG_CONTEXT.BASKET,
    title: 'Validation',
    hideProductList: true,
    hideDiscountAction: true,
    canPrint: false,
    canSendMail: true,
    skipCheckBomEmpty: true,
    isDisabled: stateValue => isPurchaseListEmpty(stateValue),
  },
];
